export const load = () => ({
	h1: 'Soundproof and Make Hotel Rooms more Comfortable with Window Inserts',
	title: 'Soundproof Hotels with Indow Window Inserts ',
	description:
		'Every hotel visitor wants a quiet room. Our discreet interior window inserts are ideal for soundproofing hotel windows and can reduce outside noise up to 70%.',
	showTitle: true,
});
